










import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { storeService } from '@/shared';

@Component({
    computed: {
        selectedStore: {
            get(): number {
                return this.$props.storeId;
            },
            set(val) {
                this.$emit('changeStore', val);
            },
        },
    },
    props: ['storeId', 'enterpriseId', 'hintText', 'isPersistentHint', 'showOnlyAllowedStores'],
})


export default class StoreDropDownComponent extends Vue {
    public selectedStore: string;
    public storeId: string;
    public hintText: string;
    public isPersistentHint: boolean;
    public showOnlyAllowedStores: boolean;

    public stores: any[] = [];
    public isStoreLoading: boolean = false;

    public mounted() {
        this.selectedStore = this.storeId;
        this.hintText = this.$props.hintText;
        this.isPersistentHint = this.$props.isPersistentHint;

        this.getStores();
        this.$watch('selectedStore', (newVal, oldVal) => {
            if (newVal !== oldVal) {
                this.$set(this.$attrs, 'model', newVal);
            }
        }, {
            deep: true, immediate: false,
        });

    }
    public async getStores(): Promise<void> {
        try {
            this.isStoreLoading = true;

            const response = this.showOnlyAllowedStores
                ? await storeService.getuserStoresList()
                : await storeService.getStoresList();

            this.stores = response.results;
        } finally {
            this.isStoreLoading = false;
        }
    }
}
